import { GET_PHOTOGRAPHER_ACTIVE, POST_PHOTOGRAPHER } from "constants/api"
import axios from "axios"

export const PhotographerServices = {
  upload(id: number | string, data: FormData, session: any) {
    return axios.post(POST_PHOTOGRAPHER.replace("{ID}", `${id}`), data, {headers: { Authorization: `Bearer ${session?._tokenResponse?.idToken}` }})
  },

  get(session: any) {
    return axios.get(GET_PHOTOGRAPHER_ACTIVE, {headers: { Authorization: `Bearer ${session?._tokenResponse?.idToken}` }})
  }
}